import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { IoIosArrowDropup } from 'react-icons/io';

import { Icon } from './styles';

import Home from '../Home';
import About from '../About';
import Projects from '../Projects';
import Contact from '../Contact';

export default function Main() {
   const scrollTop = () => {
     window.scrollTo({
       top: 0,
       behavior: 'smooth',
     });
   };

   useEffect(() => {
     const mybutton = document.getElementById('myBtn');

     const scrollFunction = () => {
       if (
         document.body.scrollTop > 0 ||
         document.documentElement.scrollTop > 0
       ) {
         mybutton.style.display = 'block';
       } else {
         mybutton.style.display = 'none';
       }
     };

     window.onscroll = () => {
       scrollFunction();
     };
   }, []);

  return (
    <>
      <Home />
      <About />
      <Projects />
      <Contact />
      <Toaster />
      <Icon id='myBtn'>
        <IoIosArrowDropup size='48' color='#fff' onClick={scrollTop} />
      </Icon>
    </>
  );
}
